import axios from 'axios';
import { ManualFeedListItem } from '../types/manual-feed-list-item.type';
import { ManualFeedStatusFilter } from '../types/manual-feed-status-filter.enum';
import { ManualFeed } from '../types/manual-feed.type';


// why does this expect Feed[] from the endpoint but we return a promise of FeedListItem[]?
// GET
// Returns feeds.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}​/feed
export const getManualFeedsList = async (globalCompanyId: string): Promise<ManualFeedListItem[]> => {
  const res = await axios.get<ManualFeed[]>(
    `/ewosapi/v1/feeds/manual/company/${globalCompanyId}/feed?filter=${ManualFeedStatusFilter.All}`
  );
  return res.data;
};
